// Static institution → primary web domain map, used only to fetch a small
// greyscale favicon for the country panel. New parsers still render fine
// without an entry here — they simply fall through to the letter avatar.
//
// Kept in a plain object (not per-parser fields) so growing the map does
// not require a backend redeploy.
const INSTITUTION_DOMAINS = {
  // Nigeria
  arm_ng: 'arm.com.ng',
  chapel_hill_denham_ng: 'chapelhilldenham.com',
  fbn_quest_ng: 'fbnquest.com',
  first_bank_ng: 'firstbanknigeria.com',
  gtbank_ng: 'gtbank.com',
  meristem_ng: 'meristemng.com',
  stanbic_ibtc_ng: 'stanbicibtc.com',
  uba_ng: 'ubagroup.com',
  united_capital_ng: 'unitedcapitalplcgroup.com',
  zenith_ng: 'zenithbank.com',

  // South Africa
  absa_za: 'absa.co.za',
  allan_gray_za: 'allangray.co.za',
  coronation_za: 'coronation.com',
  fnb_za: 'fnb.co.za',
  investec_za: 'investec.com',
  nedbank_za: 'nedbank.co.za',
  old_mutual_za: 'oldmutual.co.za',
  psg_wealth_za: 'psg.co.za',
  sanlam_za: 'sanlam.co.za',
  standard_bank_za: 'standardbank.co.za',

  // United Kingdom
  aj_bell_gb: 'ajbell.co.uk',
  barclays_gb: 'barclays.co.uk',
  coutts_gb: 'coutts.com',
  hargreaves_lansdown_gb: 'hl.co.uk',
  hsbc_uk_gb: 'hsbc.co.uk',
  interactive_investor_gb: 'ii.co.uk',
  lloyds_gb: 'lloydsbank.com',
  natwest_gb: 'natwest.com',
  rathbones_gb: 'rathbones.com',
  sjp_gb: 'sjp.co.uk',

  // United Arab Emirates
  adcb_ae: 'adcb.com',
  adib_ae: 'adib.ae',
  cbd_ae: 'cbd.ae',
  dib_ae: 'dib.ae',
  emirates_islamic_ae: 'emiratesislamic.ae',
  emirates_nbd_ae: 'emiratesnbd.com',
  fab_ae: 'bankfab.com',
  hsbc_uae_ae: 'hsbc.ae',
  mashreq_ae: 'mashreqbank.com',
  rakbank_ae: 'rakbank.ae',

  // Kenya
  britam_ke: 'britam.com',
  cooperative_ke: 'co-opbank.co.ke',
  dtb_ke: 'dtbafrica.com',
  equity_bank_ke: 'equitygroupholdings.com',
  icea_lion_ke: 'icealion.com',
  im_bank_ke: 'imbankgroup.com',
  kcb_ke: 'kcbgroup.com',
  ncba_ke: 'ncbagroup.com',
  stanbic_ke: 'stanbicbank.co.ke',
  stanchart_ke: 'sc.com',

  // Ghana
  access_gh: 'ghana.accessbankplc.com',
  cbg_gh: 'cbg.com.gh',
  databank_gh: 'databankgroup.com',
  ecobank_gh: 'ecobank.com',
  fidelity_gh: 'fidelitybank.com.gh',
  gcb_gh: 'gcbbank.com.gh',
  ic_asset_gh: 'ic.africa',
  republic_gh: 'republicghana.com',
  stanbic_gh: 'stanbicbank.com.gh',
  stanchart_gh: 'sc.com',

  // Singapore
  citibank_sg: 'citibank.com.sg',
  dbs_sg: 'dbs.com.sg',
  endowus_sg: 'endowus.com',
  maybank_sg: 'maybank2u.com.sg',
  ocbc_sg: 'ocbc.com',
  saxo_sg: 'home.saxo',
  stanchart_sg: 'sc.com',
  stashaway_sg: 'stashaway.sg',
  syfe_sg: 'syfe.com',
  uob_sg: 'uob.com.sg',

  // United States
  fidelity_us: 'fidelity.com',
  goldman_sachs_us: 'goldmansachs.com',
  interactive_brokers_us: 'interactivebrokers.com',
  jpmorgan_us: 'jpmorgan.com',
  merrill_us: 'ml.com',
  morgan_stanley_us: 'morganstanley.com',
  schwab_us: 'schwab.com',
  ubs_us: 'ubs.com',
  vanguard_us: 'vanguard.com',
  wells_fargo_us: 'wellsfargo.com',

  // Canada
  bmo_ca: 'bmo.com',
  cibc_ca: 'cibc.com',
  manulife_ca: 'manulife.ca',
  national_bank_ca: 'nbc.ca',
  questrade_ca: 'questrade.com',
  rbc_ca: 'rbcroyalbank.com',
  scotiabank_ca: 'scotiabank.com',
  sun_life_ca: 'sunlife.ca',
  td_ca: 'td.com',
  wealthsimple_ca: 'wealthsimple.com',
};

export const getInstitutionDomain = (institutionId) =>
  INSTITUTION_DOMAINS[institutionId] || null;

export default INSTITUTION_DOMAINS;
